export type BunkerRewardItemType = {
  id: string | number
  percent?: number
  multiplier?: number
  exp?: number
  topDes: string
  bottomDes: string
}

export type BunkerInventoryItemType = {
  id: string | number
  imgUrl: string
  isLocked: boolean
}

export type BunkerEquipCardType = {
  part: string
  equipName: string
  rarity: string
}

export const bunkerRewardData: BunkerRewardItemType[] = [
  {
    id: 1,
    percent: 0.1,
    topDes: 'Staking',
    bottomDes: 'Multiplier',
  },
  {
    id: 2,
    percent: 0.3,
    topDes: 'Rakeback',
    bottomDes: 'Bonus',
  },
  {
    id: 3,
    percent: 3,
    topDes: 'XP',
    bottomDes: 'Boost',
  },
  {
    id: 4,
    percent: 0.5,
    topDes: 'Lootbox Odds',
    bottomDes: 'Increase',
  },
  {
    id: 5,
    percent: 0.5,
    topDes: 'Cashback in',
    bottomDes: 'PrimeRoll',
  },
  {
    id: 6,
    percent: 2,
    topDes: 'Total Bonus',
    bottomDes: 'Multiplier',
  },
  {
    id: 7,
    percent: 0.3,
    topDes: 'Rakeback',
    bottomDes: 'Bonus',
  },
  {
    id: 8,
    multiplier: 1.4,
    topDes: 'Multiplier in',
    bottomDes: 'PR Bonanza',
  },
  {
    id: 9,
    exp: 500,
    topDes: 'ONE-TIME XP',
    bottomDes: 'Vouchers',
  },
]

export const bunkerInventoryData: BunkerInventoryItemType[] = [
  { id: '1', imgUrl: '/assets/bunker/cat-1.png', isLocked: false },
  { id: '2', imgUrl: '/assets/bunker/cat-2.png', isLocked: false },
  { id: '3', imgUrl: '/assets/bunker/cat-3.png', isLocked: false },
  { id: '4', imgUrl: '/assets/bunker/cat-4.png', isLocked: true },
  { id: '5', imgUrl: '/assets/bunker/cat-5.png', isLocked: true },
  { id: '6', imgUrl: '/assets/bunker/cat-6.png', isLocked: true },
  { id: '7', imgUrl: '/assets/bunker/cat-7.png', isLocked: true },
  { id: '8', imgUrl: '/assets/bunker/cat-8.png', isLocked: true },
]

export const bunkerEquipData: BunkerEquipCardType[] = [
  {
    part: 'FUR',
    equipName: 'COLDFRONT BASIC',
    rarity: 'COMMON',
  },
  {
    part: 'EYES',
    equipName: 'MAD BLUE',
    rarity: 'UNCOMMON',
  },
  {
    part: 'MOUTH',
    equipName: 'ARGH',
    rarity: 'COMMON',
  },
  {
    part: 'EARS',
    equipName: 'GALAXY SILVER',
    rarity: 'RARE',
  },
  {
    part: 'VENTS',
    equipName: 'GALAXY SILVER',
    rarity: 'COMMON',
  },
  {
    part: 'HELMET',
    equipName: 'GALAXY SILVER',
    rarity: 'LEGENDARY',
  },
  {
    part: 'VISOR',
    equipName: 'GALAXY SILVER',
    rarity: 'COMMON',
  },
  {
    part: 'NECK',
    equipName: 'GALAXY SILVER',
    rarity: 'RARE',
  },
  {
    part: 'ARMOR',
    equipName: 'GALAXY SILVER',
    rarity: 'LEGENDARY',
  },
]

export type BunkerDataType = {
  part: string
  equipName: string
  rarity: string
  inventories: BunkerInventoryItemType[]
  rewards: BunkerRewardItemType[]
}

export const data: BunkerDataType[] = []
